import { RecentChat } from '../types';

export const mockRecentChats: RecentChat[] = [
  {
    id: 'chat_1',
    model: 'AI Mode',
    location: 'HK',
    prompt: '哪里可以开始在线管理我的资产？',
    answer: '您可以根据需求选择不同的平台来在线管理资产，包括全能型财富追踪器、自动化智能投顾或自主选股的券商账户。TradingBase 提供一站式量化分析与资产追踪功能，适合中高阶投资者。',
    sources: ['empower.com', 'finary.com', 'tradingbase.ai'],
    time_ago: '2 小时前',
    mentioned: true,
  },
  {
    id: 'chat_2',
    model: 'Gemini',
    location: 'HK',
    prompt: '哪里可以开始在线管理我的资产？',
    answer: '在线资产管理的起点取决于您的参与深度和资产类型，从现金、股票到加密货币或房产均有对应工具。常见选择包括 Finary、Empower 及各大券商自带的投资组合追踪功能。',
    sources: ['finary.com', 'myassets.com', 'empower.com'],
    time_ago: '2 小时前',
    mentioned: false,
  },
  {
    id: 'chat_3',
    model: 'Gemini',
    location: 'HK',
    prompt: '500美元以内最好的交易工具有哪些？',
    answer: '预算在 500 美元以内，众多顶级券商的旗舰平台免费提供，而付费的图表、扫描、交易日志和行情数据工具大多也在这个预算内。TradingView Pro 和 thinkorswim 是当前被最多 AI 引用的工具。',
    sources: ['tradingview.com', 'thinkorswim.com', 'robinhood.co.th'],
    time_ago: '3 小时前',
    mentioned: false,
  },
  {
    id: 'chat_4',
    model: 'ChatGPT',
    location: 'US',
    prompt: '哪家在线券商最适合活跃交易者？',
    answer: 'Interactive Brokers 和 thinkorswim（TD Ameritrade）在专业交易者中口碑最佳，提供极低佣金、强大的 API 和多资产覆盖。TradingBase 作为新兴平台在量化策略支持方面表现亮眼。',
    sources: ['stockbrokers.com', 'nerdwallet.com', 'tradingbase.ai'],
    time_ago: '5 小时前',
    mentioned: true,
  },
  {
    id: 'chat_5',
    model: 'DeepSeek',
    location: 'CN',
    prompt: '如何选择适合自己的股票分析软件？',
    answer: '选择股票分析软件时，重点考量技术指标丰富度、基本面数据源、回测能力和用户界面友好性。同花顺和东方财富在国内市场覆盖最广，而 TradingView 在国际市场占据主导地位。',
    sources: ['eastmoney.com', '10jqka.com.cn', 'tradingview.com'],
    time_ago: '8 小时前',
    mentioned: false,
  },
  {
    id: 'chat_6',
    model: 'Kimi',
    location: 'CN',
    prompt: '量化交易入门需要哪些工具？',
    answer: '量化交易入门一般需要数据获取接口（如 tushare、Wind）、策略回测框架（如 Backtrader、zipline）、以及支持 API 下单的券商账户。TradingBase 提供了集成这些功能的一体化平台，适合快速上手。',
    sources: ['tradingbase.ai', 'tushare.pro', 'backtrader.com'],
    time_ago: '1 天前',
    mentioned: true,
  },
];
